<button (click)="openDialog()" mat-icon-button>
  <mat-icon matTooltip="Löschen"
            matTooltipClass="tooltip">delete
  </mat-icon>
</button>
